import { Spinner } from '@frontend/components';

export const HintLoadingSpinner = () => {
  return <Spinner size="sm" />;
};
